<div class="content-card" fxLayout="row wrap" fxLayoutGap="10px">
  <div>
    <mat-card  *ngIf="order" class="container-md">
      <mat-card-header fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="space-between center">
          <mat-card-title>
              <h5>Vouchers</h5>
          </mat-card-title>
          <div fxFlex></div>
          <button *ngIf="canManage() && ![voucherOrderStatus.Canceled].includes(order.voucherOrderStatus)"
            [disabled]="[voucherOrderStatus.Inactive].includes(order.voucherOrderStatus)"
            mat-raised-button color="primary" (click)="regenerateVoucherOrder()">
              Regenerate
          </button>
          <button *ngIf="isAdmin() && [voucherOrderStatus.Pending].includes(order.voucherOrderStatus)" mat-raised-button color="primary" (click)="markAsPaid()"> Mark as paid</button>
      </mat-card-header>
      <mat-card-content>
          <table class="list-table">
              <tr *ngFor="let field of fields">
                  <td class="secondary">{{ field.header }}</td>
                  <td *ngIf="order">{{ field.cell(order) }}</td>
              </tr>
          </table>
      </mat-card-content>
      <mat-card-actions align="end">
          <button *ngIf="canManage() && [voucherOrderStatus.Inactive].includes(order.voucherOrderStatus)" mat-raised-button color="primary" (click)="activateVoucherOrder()">Activate</button>
          <button *ngIf="canManage() && [voucherOrderStatus.Active].includes(order.voucherOrderStatus)" mat-raised-button color="accent" (click)="deactivateVoucherOrder()">Deactivate</button>
          <button *ngIf="![voucherOrderStatus.Canceled].includes(order.voucherOrderStatus) && isAdmin()" mat-raised-button color="accent" (click)="cancelVoucherOrder()">Cancel</button>
          <div fxFlex></div>
          <button *ngIf="canSee()"
              title="Please verify invoice configuration settings or contact administrator for aditional support"
              mat-raised-button
              color="primary"
              (click)="downloadAttachment()"
              [disabled]="!order?.invoice?.pdfId">
              {{order?.invoice?.pdfId ? "Download Invoice PDF Attachment" : "Invoice PDF file not available"}}
          </button>
          <a mat-raised-button color="primary" (click)="returnBack()">Back</a>

      </mat-card-actions>
    </mat-card>
  </div>
  <mat-card class="container-md">
    <mat-card-header  fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="space-between center">
        <mat-card-title>
            <h5>Vouchers</h5>
        </mat-card-title>
        <div fxFlex></div>
        <a *ngIf="canManage()" mat-raised-button color="primary" (click)="downloadVouchers()">Download Vouchers</a>
    </mat-card-header>
    <mat-card-content>
      <app-mat-table-generator #vouchersTable
        tableName = "vouchersTable"
        [columns] ="voucherColumns"
        [defaultSortField]="'id'"
        [defaultSortDirection]="'desc'"
        [dataSource] ="vouchersDataSource"
        [deleteEnabled]="false"
        [multiselectEnabled]="false"
        >
    </app-mat-table-generator>
    </mat-card-content>
  </mat-card>
</div>
